import { INgRegistrationContext } from "./types"

export function createRegistrationContext(ngmodule: ng.IModule) {

    const registrationContext: INgRegistrationContext = {
        directive: null,
        service: null
    }

    ngmodule.config(["$provide", "$compileProvider", "$routeProvider", ($provide, $compileProvider) => {

        registrationContext.service = (name, ctor) => {
            $provide.service(name, ctor);
            return <any>registrationContext;
        }

        registrationContext.directive = (name, factory) => {
            $compileProvider.directive(name, factory);
            return <any>registrationContext;
        }

    }])

    return registrationContext

}
